<template>
    <div ref="printPdf">
        <b-container class="mt-5">
        <b-card class="p-5">
            <b-row>
                <b-col cols="12" class="d-flex align-items-center justify-content-between mb-3">
                    <img src="../../../assets/img/BAU_Logo.png" height="75" alt="BAU Logo"     ref="logoImage"
                    />
                </b-col>
                <b-col>
                    <h4 class="mt-3 text-center font-weight-bold">{{ $t('transfer_out_form') }}</h4>
                </b-col>
            </b-row>
            <b-row>
                <!-- Student Info -->
              <b-col cols="12" md="6">
                <b-form-group :label="$t('sevis_id')">
                  <b-form-input :value="studentData.sevis_id" readonly />
                </b-form-group>
              </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('student_number')">
                        <b-form-input :value="studentData.student_number" readonly />
                    </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                    <b-form-group :label="$t('student_name')">
                        <b-form-input :value="studentData.name + ' ' + studentData.surname" readonly />
                    </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                    <b-form-group :label="$t('program_name')">
                        <b-form-input :value="studentData.program_name" readonly />
                    </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                    <b-form-group :label="$t('state_name')">
                        <b-form-input :value="studentData.contact_state_name" readonly />
                    </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                    <b-form-group :label="$t('city')">
                        <b-form-input :value="studentData.contact_city_name" readonly />
                    </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                    <b-form-group :label="$t('email')">
                        <b-form-input :value="studentData.email" readonly />
                    </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                    <b-form-group :label="$t('mobile_tel')">
                        <b-form-input :value="studentData.mobile_tel_country_code + studentData.mobile_tel" readonly />
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group :label="$t('address')">
                        <b-form-textarea :value="studentData.contact_address" readonly />
                    </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                    <b-form-group :label="$t('module')">
                        <b-form-input :value="studentData.module" readonly />
                    </b-form-group>
                </b-col>

                <hr class="w-100 yellow-line" />

                <!-- Transfer Form -->
                <b-col cols="12">
                    <b-form-group :label="$t('reason_for_transferring_out')">
                        <b-form-input :value="form.reason" readonly />
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group :label="$t('explanation')">
                        <b-form-textarea :value="form.explanation" readonly />
                    </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                    <b-form-group :label="$t('new_institution')"  :description="$t('new_institution_description')">
                        <university-selectbox
                            v-model="form.new_institution_id" disabled>
                        </university-selectbox>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('new_program_of_study')">
                        <parameter-selectbox v-model="form.new_program_of_study"
                                             code="transfer_out_new_program_of_studies"
                                             disabled/>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('new_subject_of_study')">
                        <parameter-selectbox v-model="form.new_subject_of_study"
                                             code="transfer_out_new_subject_of_studies"
                                             disabled/>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('new_sevis_school_code')">
                        <b-form-input :value="form.school_sevis_code" readonly />
                    </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                    <b-form-group :label="$t('start_date')">
                        <b-form-input :value="form.program_start_date" readonly />
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    {{ new Date().toLocaleString() }}
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center">
                <b-form-group>
                    <b-button variant="primary" @click="changeToHtml">{{ $t('save') }}</b-button>
                </b-form-group>
            </div>
        </b-card>

    </b-container>
    </div>
</template>
<script>
import TransferOutRequestMentora from '@/services/TransferOutRequestMentora';
import moment from "moment";
import UniversitySelectbox from "@/components/interactive-fields/UniversitySelectbox.vue";

export default {
    components: {UniversitySelectbox},
  computed: {
    moment() {
      return moment
    }
  },
    props: {
        studentData: {
            type: Object,
            required: true
        },
        form: {
            type: Object,
            required: true
        }
    },
    methods:{
        getBase64Image(img) {
            return new Promise((resolve, reject) => {
                const image = new Image();
                image.crossOrigin = 'Anonymous';
                image.src = img;
                image.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = image.width;
                    canvas.height = image.height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(image, 0, 0);
                    const dataURL = canvas.toDataURL('image/png');
                    resolve(dataURL);
                };
                image.onerror = (error) => {
                    reject(error);
                };
            })
        },
        async changeToHtml() {
            const printPdf = this.$refs.printPdf;
            const logoImage = this.$refs.logoImage;
            const logoBase64 = await this.getBase64Image(logoImage.src);
            logoImage.src = logoBase64;
            const htmlString = printPdf.outerHTML;
            const base64String = btoa(unescape(encodeURIComponent(htmlString)));
            await this.save(base64String);
        },
        async save(base64String){
            const formData=new FormData()
            formData.append('html',base64String)
            Object.entries(this.form).forEach(([key, value]) => {
                formData.append(key, value)
            })
            try {
                const res=await TransferOutRequestMentora.save(formData)
                this.$toast.success(this.$t(res.data.message))
                this.$router.push('/my-mentora-requests/2')
            }catch (error){
                this.$emit('formError',error)
            }
        }
    }
};
</script>

<style scoped>
.yellow-line {
    border-top: 2px solid #ffc107;
}
</style>
